module.exports = __webpack_public_path__ + "img/scratch-with-cat.aad5912c.jpeg";